module.exports = __webpack_public_path__ + "static/media/opening-lithonia-medical-center.e086efaf.jpg";